import CollapsibleContentFull from './CollapsibleContentFull';

export default CollapsibleContentFull;
